import GlobalShoppingDefaultProvider from '@psl/flows/shop/provider/default';
import { memo, ReactNode } from 'react';

export const GlobalShoppingContextProvider = memo(
  ({ children }: { children?: ReactNode }) => {
    return (
      <GlobalShoppingDefaultProvider>{children}</GlobalShoppingDefaultProvider>
    );
  },
);
